import React from 'react'
import Modal from 'react-bootstrap/Modal';

export const ModalClasico = ({show,size,children}) => {

  return (
    <Modal
        show={show}
        size={size}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
    >
    {/* <Modal.Header >
        <div className=''></div>
            
    </Modal.Header> */}

    <Modal.Body>
       {children}        
    </Modal.Body>
    {/* <Modal.Footer >        
    </Modal.Footer> */}
  </Modal>
  )
}
